module.exports = __webpack_public_path__ + "img/08_EN.4b21c521.jpg";